import { reactive, ref, computed, onMounted, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import axios from '@/util/axios'
import CryptoJS from 'crypto-js'
import * as apiLogin from '@/api/login'
import * as apiProfile from '@/api/profile'
import * as apiPayment from '@/api/payment'
import * as validation from '@/util/validation'
import * as apiContract from '@/api/contract'
import { gtmLogWithUID } from '@/util/log'


export const getGroup = (props, context) => {

  // ログイン情報をローカルストレージに保存するためのキー名
  const LOCAL_STORAGE_KEY_LOGIN = 'LOGIN_CACHE'
  // パスワードを保存チェック状態をローカルストレージに保存するためのキー名
  const LOCAL_STORAGE_KEY_SAVE_PASS = 'STORAGE_1'
  // AES暗号化キー（書き換えないこと）
  const AES_SECRET_PASSPHRASE = 'vtFZ10pOqdzxJlNQNVHAqbxIkRtWC8pn'

  const group1 = reactive({

    loginId: '',
    password: '',
    savePassword: true, // パスワードを保存する

    // 入力エラーメッセージ
    error_loginId: '',
    error_password: '',

    // スライドショーのリスト
    slideList: [],

    /**
     * 初期表示
     */
    init: () => {

      // ローカルストレージからパスワードを保存チェック状態のキャッシュを取得
      const savePassJSON = localStorage.getItem(LOCAL_STORAGE_KEY_SAVE_PASS)
      if (savePassJSON) {
        try {
          const data = JSON.parse(savePassJSON)
          group1.savePassword = !(data.save_password === 0)
        } catch (e) {
        }
      }

      // ローカルストレージからログイン入力情報のキャッシュを取得
      const encryptedText = localStorage.getItem(LOCAL_STORAGE_KEY_LOGIN)
      if (encryptedText) {
        // ローカルストレージからログイン入力情報のキャッシュがある場合
        // 復号する(CryptoJSのデフォルトはCBCモード)
        const loginCacheJson = CryptoJS.AES.decrypt(encryptedText, AES_SECRET_PASSPHRASE).toString(CryptoJS.enc.Utf8)
        try {
          const data = JSON.parse(loginCacheJson)

          // ログインIDとパスワードを入力欄に設定
          group1.loginId = data.login_id
          group1.password = data.password

        } catch (e) {
        }
      }

      // スライドショー生成
      const slideshowRootPath = '/lc/app/top_slideshow/'
      const slideshowJsonURL = slideshowRootPath + 'pc_top_slideshow.json?' + Date.now()
      axios.get(slideshowJsonURL)
        .then(async(response) => {

          if (response.data) {
            const data = response.data
            const slideListWork = []

            for (let i = 0; i < data.length; i++) {
              const htmlURL = slideshowRootPath + data[i]
              await axios.get(htmlURL)
                .then(response => {
                  if (response.data) {
                    const html = response.data

                    const no = i + 1
                    let slideId
                    if (no <= 9) {
                      slideId = 'content-0' + no
                    } else {
                      slideId = 'content-' + no
                    }

                    const map = {
                      slide_id: slideId,
                      html: html
                    }
                    slideListWork.push(map)
                  }
                })
            }
            group1.slideList = slideListWork
          }

        })

      if (
        // タイムアウトしてログイン画面に強制遷移した場合
        store.state.login.isTimeoutMessageShown &&
        // ログアウト実行後にブラウザバックするとタイムアウトが表示されない対策のための判定
        !store.state.common.isLoggedOut
      ) {
        // タイムアウトNoticeの表示
        // title, textの値はcommon/showNoticeメソッドの中で設定する
        store.dispatch('common/showNotice', { title: '', text: '' })
      }
    },

    /**
    * ログインボタンを押した場合
    */
    onLoginButtonClicked: () => {

      // タイムアウト時にログイン画面に遷移した時にNotice表示する判定フラグをリセット
      // ※ router.beforeEach()内でもリセット処理をしているが、その処理は遷移するタイミングであり、
      // その前のAPIリクエスト処理に対応できないので、ここ（ログインボタン押下したタイミング）でもリセットしておく。
      store.dispatch('login/setIsTimeoutMessageShown', false)

      // ログアウト実施完了フラグをfalseで初期化
      store.dispatch('common/setIsLoggedOut', false)

      // 入力チェック
      let isError = false
      group1.error_loginId = ''
      group1.error_password = ''

      const loginErrorMessage = 'メールアドレスまたはパスワードが間違っています。'
      if (group1.loginId === '') {
        group1.error_password = loginErrorMessage
        isError = true
      // } else if (!validation.checkHankaku(group1.loginId) || !validation.checkMinLength(group1.loginId, 8)) {
      //  group1.error_password = loginErrorMessage
      //   isError = true
      } else if (!validation.checkHankaku(group1.loginId) || !validation.checkMaxLength(group1.loginId, 256)) {
        group1.error_password = loginErrorMessage
        isError = true
      }
      if (group1.password === '') {
        group1.error_password = loginErrorMessage
        isError = true
      } else if (!validation.checkHankaku(group1.password) || !validation.checkMinLength(group1.password, 8)) {
        group1.error_password = loginErrorMessage
        isError = true
      } else if (!validation.checkHankaku(group1.password) || !validation.checkMaxLength(group1.password, 16)) {
        group1.error_password = loginErrorMessage
        isError = true
      }

      if (isError) {
        // 入力エラーが存在した場合
        return false
      }


      if (group1.savePassword) {
        // 「パスワードを保存する」がチェックされている場合

        // 入力したログイン情報をJSON形式にして、暗号化して、ローカルストレージに保存する
        const inputData = {
          login_id: group1.loginId,
          password: group1.password
        }
        const inputDataJson = JSON.stringify(inputData)
        // 暗号化(CryptoJSのデフォルトはCBCモード)
        const encryptedText = CryptoJS.AES.encrypt(inputDataJson, AES_SECRET_PASSPHRASE).toString()
        // ローカルストレージに保存
        localStorage.setItem(LOCAL_STORAGE_KEY_LOGIN, encryptedText)
      } else {
        // 「パスワードを保存する」がチェックされていない場合
        // ローカルストレージに保存しているデータを削除
        localStorage.removeItem(LOCAL_STORAGE_KEY_LOGIN)
      }

      // パスワードを保存チェック状態をローカルストレージに保存
      const inputData2 = {
        save_password: group1.savePassword ? 1 : 0
      }
      const inputDataJson2 = JSON.stringify(inputData2)
      localStorage.setItem(LOCAL_STORAGE_KEY_SAVE_PASS, inputDataJson2)

      // ログイン処理を実行する
      group1.login()
    },

    /**
     * ログイン処理を実行する
     */
    login: () => {

      // ログインAPIをコール
      const params = {}
      params.login_id = group1.loginId
      params.email = group1.loginId
      params.password = group1.password

      apiLogin.login(params)
        .then(response => {

          if (response) {
            const { data } = response
            const status = data.status ?? -1
            const errorMessage = data.error_message ?? ''

            if (status === 0) {
              // ログイン成功

              // トークンを保存
              store.dispatch('auth/setToken', {
                token: data.token,
                refreshToken: data.refresh_token
              })

              // プロフィール情報を取得し、ストアに保存（既存があれば上書き）する
              // ※store.dispatch('profile/fetch') を使用した場合、プロフィール取得APIからデータを取得するよりも前に、
              // 　ストアにデータが保存される問題がある（async-awaitが想定通りに動作していない）
              // 　よって、store.dispatch('profile/fetch')を使用せず、apiProfile.fetch()メソッドを使用する

              // プロフィール取得APIをコール
              const params = {}

              apiProfile.fetch(params)
                .then(response => {
                  const data = response.data
                  if (data.status === 0) {

                    const saved = { ...data }
                    delete saved.status
                    delete saved.error_message

                    store.dispatch('profile/setProfile', saved)

                    // 利用者アイコンを取得
                    store.dispatch('profile/getUserImage')

                    // ログインした記録をGAに送信
                    gtmLogWithUID('ga-login')

                    // 支払いの状態を取得するため、
                    // SN-010 申請情報取得APIをコール
                    const identificationCode = store.state.profile.identification_code
                    const params2 = {
                      identification_code: identificationCode // 契約識別コード
                    }
                    apiPayment.fetchApplicationInfo(params2)
                      .then(response => {
                        if (response) {
                          const { data } = response
                          const status = data.status
                          if (status === 0) {
                            // リーガルコネクションの申請状況
                            const lcResult = data['2']
                            // 状態コード (1:受付 2:審査中 3:有効 4:停止 8:却下 9:解約 97:契約削除 98:合併 99:退会)
                            // ※審査中は「1:受付 or 2:審査中」、審査完了は「3:有効」である
                            let lcRequest = parseInt(lcResult.request)
                            if (isNaN(lcRequest)) {
                              lcRequest = 0
                            }

                            // 状態コードをストアに保持
                            store.dispatch('payment/setRequest', lcRequest)
                          }
                        }
                      })
                      .finally(() => {
                        // 次の処理について
                        // SN-010 でユーザーに対する情報が必ず取得できるか分からないので、
                        // finallyで処理

                        // 次の画面に遷移する(ログイン成功時用)
                        group1.goToNextPage()
                      })
                  }
                })

            } else if (status === 423) {
              // status=423: 連続ログイン失敗時など
              store.dispatch('common/showNotice', { title: 'エラー', text: errorMessage })
            } else if (status === 429) {
              // status=429: 同一アカウントでの同時ログイン数が上限を超えた場合

              const payload = {
                title: '確認',
                text: 'ログインを続行すると現在ログイン中の全端末がログアウトされます。\nログインを続けますか？',
                button1: {
                  show: true,
                  text: '閉じる',
                  action: null
                },
                button2: {
                  show: true,
                  text: 'ログインを続ける',
                  action: async () => {

                    // ログイントークンリセットAPIをコール
                    const params2 = {}
                    params2.login_id = group1.loginId
                    params2.password = group1.password

                    await apiLogin.resetToken(params2)
                      .then(response => {
                        if (response) {

                          const { data } = response
                          const status = data.status ?? -1

                          if (status === 0) {
                            // ログイン処理を再度実行する
                            group1.login()
                          } else {
                            setTimeout(() => {
                              store.dispatch('common/showNotice', { title: 'エラー', text: 'ログインに失敗しました。' })
                            }, 1000)
                          }
                        }
                      })
                  }
                }
              }
              store.dispatch('common/showNotice', payload)

            } else {
              // status=その他: エラーダイアログを表示
              group1.error_password = 'ログインに失敗しました。'
            }

          }
        })
    },

    /**
     * 次の画面に遷移する(ログイン成功時用)
     */
    goToNextPage: () => {
      if (store.state.login.destinationURI !== '') {
        // 遷移先URLを指定してログインした場合は、そのURLに遷移

        const destinationURI = store.state.login.destinationURI

        // 遷移先URIをクリア
        store.dispatch('login/setDestinationURI', '')

        // 遷移
        router.push({ path: destinationURI })
      } else {
        // ダッシュボードに遷移
        if (store.state.common.device === 'sp') {
          router.push({ path: '/sp/dashboard' })
        } else {
          router.push({ path: '/pc/dashboard' })
        }
      }
    },

    /**
     * 新規契約申込ボタンクリック
     * webセッションを取得して、ログイン済みかどうかを判定する
     */
    onNewContractButtonClicked: () => {
      const params = {}
      params.member_param = group1.member_param
      return apiContract.getWebSession(params)
        .then(response => {
          group1.isWebSessionFetched = true
          if (response) {
            const { data } = response
            const status = data.status
            if (status === 0) {
              // WEBセッション情報取得API ログイン済みの場合
              router.push({ path: '/public/new-application/index' })
            } else {
              // WEBセッション情報取得API 未ログインの場合
              router.push({ path: '/public/select-application/index' })
            }
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    }
  })

  return group1
}
